module.exports = __webpack_public_path__ + "3beb0e8602f45e4c6fbc166f5934835c.png";